import { useEffect, useState } from 'react';

interface RotatingPromptProps {
  prompts: readonly string[];
  intervalMs?: number;
}

export function RotatingPrompt({ prompts, intervalMs = 3500 }: RotatingPromptProps) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (prompts.length <= 1) return;
    const id = window.setInterval(() => {
      setIndex((i) => (i + 1) % prompts.length);
    }, intervalMs);
    return () => window.clearInterval(id);
  }, [prompts.length, intervalMs]);

  return (
    <span className="relative h-5 min-w-0 flex-1 overflow-hidden text-left">
      <span
        key={index}
        className="absolute inset-0 truncate leading-5 duration-500 animate-in fade-in-0 slide-in-from-bottom-2"
      >
        {prompts[index]}
      </span>
    </span>
  );
}
